import { createFileRoute } from '@tanstack/react-router';
import { useIntl } from 'react-intl';
import { Head } from '@_/components';
import { FollowingPage } from '#src/pages/SavedItemsPage/index.ts';

export const Route = createFileRoute('/{-$locale}/_auth/following')({
  component: RouteComponent
});

function RouteComponent() {
  const intl = useIntl();

  return (
    <>
      <Head>
        <title>
          {intl.formatMessage({
            id: 'head.following',
            defaultMessage: 'Following'
          })}
        </title>
      </Head>

      <FollowingPage />
    </>
  );
}
